// 慧声外呼页面
<template>
  <el-row type="flex" justify="center" class="huisheng_call">
    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="huisheng_call_top">
      <el-row type="flex" justify="center">
        <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15">
          <div data-aos="fade-right" class="huisheng_call_top_text" :style="{'margin-left': isMobile ? '2em' : ''}">
            <div class="huisheng_call_top_text_1">
              <span>慧声智能外呼机器人</span>
            </div>
            <div class="huisheng_call_top_text_2">
              <span>高效率工作、低成本管理，企业的AI智能外呼助手</span>
            </div>
            <el-button type="text" class="huisheng_call_top_text_btn" @click="showDialog()">抢先报名体验产品</el-button>
          </div>
        </el-col>
      </el-row>
    </el-col>
    <add-dialog v-if="showAddDialog" :SHOW.sync="showAddDialog"></add-dialog>
  </el-row>
</template>

<script>
import goProduce from "@/util/produce.js";
import AddDialog from "@/components/Dialog.vue";
import ResizeEvent from "@/components/resizeEvent";

export default {
  name: "call",
  components: {
    AddDialog,
  },
  mixins: [ResizeEvent],
  data() {
    return {
      showAddDialog: false,
      // 成本效率比较数据
      lastIndex: 0,
    };
  },
  methods: {
    // 报名体验产品
    goProduce,

    PlayAudio(index) {
      // this.$message({
      //   message: "功能未开放，敬请期待",
      //   type: "warning",
      // });
      // console.log(index);
      if (index !== this.lastIndex) {
        var lastItem = this.bottomData[this.lastIndex];
        if (lastItem.playAudio != null) {
          lastItem.playAudio.pause();
          lastItem.playAudio = null;
          lastItem.pText = "点击播放录音";
          lastItem.pClass = "el-icon-video-play";
          lastItem.isPlayAudio = false;
        }
      }
      var itemData = this.bottomData[index];
      if (!itemData.isPlayAudio) {
        if (itemData.playAudio == null) {
          itemData.playAudio = new Audio(itemData.audioUrl);
        }
        itemData.playAudio.play();
        itemData.pText = "暂停";
        itemData.pClass = "el-icon-video-pause";
        itemData.isPlayAudio = true;
      } else {
        itemData.isPlayAudio = false;
        itemData.playAudio.pause();
        itemData.pText = "点击播放录音";
        itemData.pClass = "el-icon-video-play";
        itemData.isPlayAudio = false;
      }
      this.lastIndex = index;
      
    },
    showDialog() {
      this.showAddDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.huisheng_call {
  flex-wrap: wrap;
  .huisheng_call_top {
    height: 700px;
    width: 100%;
    background: url("../../assets/img/huisheng_call/call_bg_top.png") no-repeat
      center;
    color: #fff;
    border-top: 1px solid white;
    position: relative;
    // img {
    //   position: absolute;
    //   z-index: -10;
    //   height: 679px;
    //   width: 100%;
    // }
    .huisheng_call_top_text {
      // width: 60rem;
      height: 20.3rem;
      margin: 10.45rem auto 0px;
      line-height: 4.5rem;
      .huisheng_call_top_text_1 {
        height: 2.85rem;
        font-size: 3rem;
        font-weight: lighter;
      }
      .huisheng_call_top_text_2 {
        height: 1.5rem;
        font-size: 1.2rem;
        margin-top: 4rem;
        line-height: 1.5rem;
        white-space: nowrap;
        font-weight: lighter;
      }
      .huisheng_call_top_text_btn {
        width: 20rem;
        height: 3.8rem;
        margin-top: 3.95rem;
        background: rgba(255, 255, 255, 1);
        font-size: 1.8rem;
        color: rgba(32, 102, 233, 1);
        border-radius: 0;
        font-weight: 300;
      }
    }
  }
  .huisheng_call_center {
    // height: 37.5rem;
    border-top: 1px solid white;
    .huisheng_call_center_top {
      width: 35rem;
      height: 1.75rem;
      margin: 6.15rem auto 5rem;
      text-align: center;
      span {
        font-size: 1.8rem;
      }
      p {
        margin: 1rem 0;
        font-size: 0.8rem;
      }
    }
    .huisheng_call_center_body {
      // width: 60rem;
      // height: 19rem;
      flex-wrap: wrap;
      margin: 0 auto 6rem;
      border-top: 1px solid white;
      // display: flex;
      background: rgba(255, 255, 255, 1);
      strong {
        color: #5772fe;
      }

      .huisheng_call_center_body_item {
        // width: 22rem;
        // flex: 1;
        // flex-wrap: wrap;
        margin: 0 auto;
        padding: 0 1.5rem;
        border-right: 1px solid #eee;
        img {
          display: block;
          width: 3.95rem;
          margin: 0 auto 3rem;
        }
        .title {
          font-size: 1.75rem;
          line-height: 1.8rem;
          margin: 0 auto 2.5rem;
        }
        .text {
          height: 1.2rem;
          font-size: 1.2rem;
          line-height: 30px;
          margin: 0 auto 1.9rem;
        }
        .textList {
          font-size: 0.7rem;
          color: rgba(51, 51, 51, 1);
          line-height: 22px;
        }
        @media only screen and (max-width: 997px) {
          width: 90%;
          padding: 2em;
          margin-bottom: 2em;
          box-shadow: 1px 1px 10px rgba($color: #000000, $alpha: 0.4);
        }
      }
      & div:last-child {
        border-right: none;
      }
    }
  }
  .huisheng_call_center2 {
    // height: 50rem;
    width: 100%;
    background: rgba(247, 248, 252, 1);
    border-top: 1px solid white;
    padding-bottom: 6em;
    .call_center2_top {
      height: 1.8rem;
      // width: 50rem;

      text-align: center;
      margin: 6.2rem auto 5rem;
      span {
        font-size: 1.8rem;
      }
      p {
        margin: 1rem 0;
        font-size: 0.8rem;
      }
    }
    .call_center2_body {
      height: 32rem;
      width: 100%;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 2px 20px 0px rgba(1, 1, 1, 0.2);
      position: relative;
      .center2_body_center {
        width: 25rem;
        height: 34rem;
        position: absolute;
        top: -1rem;
        left: 17.525rem;
        background: rgba(242, 244, 254, 1);
        border: 1px solid rgba(87, 114, 254, 1);
        box-shadow: 0px 2px 20px 0px rgba(87, 114, 254, 0.2);
        z-index: 1;
      }
      .center2_body_table {
        position: absolute;
        left: 0;
        top: 0px;
        width: 60.05rem;
        font-weight: 500;
        z-index: 20;
        & div:last-child {
          border: none;
        }
        .table_item {
          height: 3.95rem;
          // width: 100%;
          line-height: 3.95rem;
          border-bottom: 0.1px solid #eeeeee;
          p {
            display: inline-block;
            font-size: 0.9rem;
            padding-left: 2rem;
            box-sizing: border-box;
          }
          & p:nth-child(1) {
            // margin-left: 5rem;
            width: 17rem;
          }
          & p:nth-child(2) {
            // margin-left: 8.6rem;
            width: 25rem;
          }
          & p:nth-child(3) {
            width: 17rem;
            // margin-left: 12rem;
          }
        }
        .table_item_title {
          p {
            font-size: 1.25rem;
            font-weight: 400;
          }

          & p:nth-child(2) {
            color: #5772fe;
          }
        }
      }
    }
    .mobile_center2_body{
      padding: 20px 0;
      margin: 0 auto;
      // .center2_body_center {
      //   width: 25rem;
      //   height: 34rem;
      //   position: absolute;
      //   top: -1rem;
      //   left: 17.525rem;
      //   background: rgba(242, 244, 254, 1);
      //   border: 1px solid rgba(87, 114, 254, 1);
      //   box-shadow: 0px 2px 20px 0px rgba(87, 114, 254, 0.2);
      //   z-index: 1;
      // }
      .center2_body_table {
        width: 100%;
        font-weight: 500;
        z-index: 20;
        position: relative;
        & div:last-child {
          border: none;
        }
        .table_item {
          line-height: 3.95rem;
          border-bottom: 0.1px solid #eeeeee;
          p {
            display: inline-block;
            font-size: 8px;
            vertical-align: middle!important;;
            box-sizing: border-box;
          }
          & p:nth-child(1) {
            width: 20%
          }
          & p:nth-child(2) {
            width: 40%;
            color: #5772fe;
          }
          & p:nth-child(3) {
            width: 40%
          }
        }
        .table_item_title {
          p {
            font-size: 1.25rem;
            font-weight: 400;
          }

          & p:nth-child(2) {
            color: #5772fe;
          }
        }
      }
    }
  }
  .huisheng_call_bottom {
    width: 100%;
    // height: 47.5rem;
    background: rgba(255, 255, 255, 1);
    margin: 0 auto 6em;
    border-top: 1px solid white;
    .call_bottom_top {
      // width: 50rem;
      height: 1.75rem;
      margin: 6.15rem auto 5.05rem;
      text-align: center;
      span {
        font-size: 1.8rem;
      }
      p {
        margin-top: 1rem;
        font-size: 0.8rem;
      }
    }
    .call_bottom_center {
      // width: 65rem;
      // height: 28rem;
      margin: 0 auto;
      // display: flex;
      flex-wrap: wrap;
      align-items: space-between;
      .bottom_item {
        // width: 27.5rem;
        // height: 12rem;
        display: flex;
        justify-content: start;
        box-sizing: border-box;
        // margin: 1.5rem 2.5rem;
        margin-bottom: 1.5rem;
        box-shadow: 0px 2px 20px 0px rgba(2, 2, 2, 0.2);
        padding: 2rem;
        @media only screen and (max-width: 997px) {
          margin: 0 2em 1.5rem;
        }
        img {
          // width: 3rem;
          height: 3rem;
          float: left;
        }
        .bottom_item_right {
          // width: 17.5rem;
          display: inline-block;
          // height: 7.5rem;
          margin-left: 1rem;

          span {
            font-weight: 500;
            font-size: 1.2rem;
            line-height: 2rem;
          }
          p {
            // height: 3rem;
            font-size: 0.7rem;
            line-height: 22px;
          }
          .audioBox {
            width: 17.5rem;
            height: 1.5rem;
            p {
              font-size: 0.8rem;
              line-height: 1.4rem;
              cursor: pointer;
            }
            p::before {
              margin-right: 0.5rem;
              line-height: 1.4rem;
              height: 1.4rem;
            }
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 997px) and (max-width: 1199px) {
  .huisheng_call_top {
    height: 500px !important;
    background-position: center;
  }
}
@media only screen and (max-width: 1600px) and (min-width: 1200px) {
  .huisheng_call_top {
    height: 600px !important;
    background-position: center;
  }
}
@media only screen and (max-width: 996px) {
  .huisheng_call_top {
    height: 300px !important;
    background-size: auto 300px !important;
    .serviceBody_top_text {
      margin-top: 50px !important;
      .serviceBody_top_text_1 {
        font-size: 2rem;
      }
    }
  }
}
</style>
<style >
.huisheng_call_center_body_item .title span strong {
  color: #5772fe;
  font-weight: 600;
}
</style>